import { cn } from "@/lib/utils";
import { type ElementType, type ReactNode, useInsertionEffect, useState } from "react";
import {
  TEXT_SHIMMER_CLASS_NAME,
  ensureTextShimmerKeyframes,
  textShimmerPhaseDelay,
  textShimmerStyle,
} from "@/lib/text-shimmer";

export interface TextShimmerProps {
  children: ReactNode;
  as?: ElementType;
  duration?: number;
  className?: string;
}

export function TextShimmer({ children, as: Comp = "span", duration = 2.5, className }: TextShimmerProps) {
  useInsertionEffect(ensureTextShimmerKeyframes, []);
  // Fixed per mount — see textShimmerPhaseDelay.
  const [delay] = useState(() => textShimmerPhaseDelay(duration));
  return (
    <Comp
      style={textShimmerStyle(duration, delay)}
      className={cn(
        "inline-block",
        TEXT_SHIMMER_CLASS_NAME,
        className,
      )}
    >
      {children}
    </Comp>
  );
}
